import '../scss/style.scss'

import { accordion } from './modules/accordion'
import { tabs } from './modules/tabs'
import { overlayMenu } from './modules/overlay-menu'
import { preload } from './modules/preload'
import { pdfLinks } from './modules/pdf-links'
import { dropdown } from './modules/dropdown'
import { header } from './modules/header'

overlayMenu()

dropdown()

pdfLinks()

preload()

accordion()

tabs()

header()